import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FullBox, Spinner } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetContentPaneSuspenseFallbackTID = (parentTestId)=>getTestIds(parentTestId);
export function ContentPaneSuspenseFallback() {
    const { ContentPaneSuspenseFallbackTID } = useMemo(()=>GetContentPaneSuspenseFallbackTID(), []);
    return /*#__PURE__*/ _jsx(FullBox, {
        centered: true,
        testId: ContentPaneSuspenseFallbackTID.Root(),
        children: /*#__PURE__*/ _jsx(Spinner, {
            size: 48
        })
    });
}
